import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getNewSeasonWorks } from '@/mocks/works';
import AnimeCard from '@/components/feature/AnimeCard';
import SectionHeading from '@/components/feature/SectionHeading';

export default function NewSeasonSection() {
  const { t } = useTranslation();
  const works = getNewSeasonWorks().slice(0, 6);

  return (
    <section className="py-12 md:py-16" aria-label={t('sec_new_season')}>
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between">
          <SectionHeading title={t('sec_new_season')} desc={t('sec_new_season_desc')} />
          <Link
            to="/category/new"
            className="mb-1 hidden items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition hover:text-primary-700 sm:flex"
          >
            {t('sec_more')}
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {works.map((work) => (
            <AnimeCard key={work.id} work={work} />
          ))}
        </div>
      </div>
    </section>
  );
}